var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPychologyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#25B8F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6143 36.6472V40H31.3675V34.6965",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6144 36.6472H20.0132V33.5179H22.9517V30.4903H26.2301V25.6947H23.8913V22.7077H21.0527V14.8642H23.8913V10.3938H20.333V9.43877C20.333 9.17462 20.493 8.9511 20.7329 8.86982C22.472 8.30086 24.7709 7.83351 27.4295 8.05703C29.0088 8.17895 31.2676 8.36184 33.6465 9.8452C34.546 10.4142 37.0048 11.9991 38.1642 15.2097C38.644 16.5711 38.7639 17.8106 38.7639 18.725C38.7639 19.2127 38.8839 19.68 39.1438 20.0864C39.8434 21.2244 41.2427 23.5205 41.9024 24.5975C42.1023 24.9226 41.9823 25.329 41.6625 25.5119L39.3037 26.8327C38.9638 27.0156 38.7639 27.4016 38.8039 27.7877C38.9638 29.2914 38.8439 30.4903 38.724 31.3031C38.5441 32.4816 38.4041 33.2538 37.8444 33.9853C36.7649 35.3874 34.9858 35.5499 34.506 35.5906C31.7874 35.8344 31.6874 35.0216 31.3676 34.6965",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7143 8.91046H14.8157V11.8568H17.7143V8.91046Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4169 11.8569H9.51831V14.8033H12.4169V11.8569Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5144 14.3563H14.6158V17.3027H17.5144V14.3563Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5144 20.2694H14.6158V23.2158H17.5144V20.2694Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6157 17.3027H11.7172V20.2491H14.6157V17.3027Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89856 16.6931H6V19.6395H8.89856V16.6931Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2974 22.0372H8.3988V24.9836H11.2974V22.0372Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8068 12.8729H29.9082V15.8193H32.8068V12.8729Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6093 15.8396H24.7107V18.786H27.6093V15.8396Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5278 18.786H27.6293V21.7324H30.5278V18.786Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0685 32.8677H26.1699V35.8141H29.0685V32.8677Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31848 33.457H6.41992V36.4034H9.31848V33.457Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8561 29.7181H10.9575V32.6645H13.8561V29.7181Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3529 29.2509H17.4543V32.1973H20.3529V29.2509Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2516 26.3044H20.353V29.2508H23.2516V26.3044Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9147 24.9835H14.0161V27.9299H16.9147V24.9835Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.413 17.3027H17.5144V20.2491H20.413V17.3027Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPychologyIcon);
export default __webpack_public_path__ + "static/media/pychologyIcon.0c7b96065bff17e7c2889fae1541b3ec.svg";
export { ForwardRef as ReactComponent };